import React from 'react'
import classNames from 'classnames'
import logo from '../../assets/images/white-logo.png'
import { Link } from 'react-router-dom'
import { Button, ButtonIcon } from '../../components/Button/Button'
import { ReactComponent as RightArrow } from '../../assets/icons/arrow-right.svg'
import { ReactComponent as DownIcon } from '../../assets/icons/Dropdown.svg'
import classes from './Business.module.css'
import gridClasses from '../../styles/grid.module.css'
import Perk1 from '../../assets/icons/perk-1-new.jpg'
import Perk2 from '../../assets/icons/perk-2-new.jpg'
import Perk3 from '../../assets/icons/perk-3-new.jpg'
import Perk4 from '../../assets/icons/perk-4-new.jpg'
import { convertToFormatted } from '../../util/functions'
import Footer from '../../components/Footer/Footer'
import heroBackgroundImage from '../../assets/images/business-homepage-new.jpg'
import { BusinessPlans } from '../../components/Plans/BusinessPlans'
import { useSelector } from 'react-redux'
import { userSelectors } from '../../redux/userSlice'
import PlansFaq from '../../components/Accordions/PlansFAQ'
import Doodle from '../../assets/images/doodle.jpg'

const FAQS = [
    {
        question: 'How many staff does my business subscription plan cover?',
        answer:
            'Depending on the plan you have selected, each plan has a range of employees you can add to it as beneficiaries.',
    },
    {
        question: 'What happens when I cancel my subscription plan?',
        answer:
            'When you cancel a subscription, automatically all FREE courses added to your plan will be removed.  You will no longer have access to all the additional benefits anymore. Also, added beneficiaries would not have access to the FREE courses initially allotted to the account. This means that you will have to begin the process of accumulation again, when you re-subscribe.',
    },
    {
        question: `How can I get an extra course, even after I've selected the allotted FREE COURSES for the month?`,
        answer:
            'To get an extra course, you would have to buy that course independently.',
    },
    {
        question: 'What are loyalty points?',
        answer:
            'Loyalty points are BONUS POINTS which could be applied as coupons on the purchase of a course or when you remain engaged with us on our social media platforms, including our blog.',
    },
    {
        question: 'How do I get loyalty points?',
        answer:
            'There are multiple ways to acquire loyalty points. It can be gifted to you as a loyal subscriber, when you interact with us on our social media platforms, through purchasing a course or participating in any of our offline or online activities.',
    },
    {
        question: 'What is the value of Loyalty Points?',
        answer:
            '1 loyalty points is equals to 1N. You can accumulate a number of loyalty points and then use it as discounts when buying a course or apply it as a one-off payment on a course if the value is equivalent to the amount for that course.',
    },
    {
        question: 'Do I get a lifetime access to the courses after payment?',
        answer: 'Yes, you get a lifetime access to every course you BUY.',
    },
    {
        question: 'How many courses can I get using my loyalty points?',
        answer:
            'Depending on the loyalty points given, you can redeem the point as coupons on a number of courses or one-off payment on a particular course if the value is equivalent to the amount for that course.',
    },
    {
        question: 'Do I get business templates when I purchase a course?',
        answer:
            'Yes. You would not only get templates, but also worksheets, canvas, flow diagrams and because our courses are step by step, you would have the opportunity to experience the hands on and practicality on how to implement what you have learnt.',
    },
]

const FAQSection = () => {
    return (
        <div className={classes.faqSection}>
            <div className={gridClasses.container}>
                <div
                    className={classNames(
                        classes.infoSection,
                        classes.infoSectionDual
                    )}
                >
                    <div className={classes.infoSectionPane}>
                        <h1
                            className={classNames(
                                classes.infoSectionTitle,
                                classes.infoSectionTitleDecorated
                            )}
                        >
                            Frequently asked questions
                        </h1>
                    </div>
                    <div className={classes.infoSectionPane}>
                        {FAQS.map(faq => (
                            <div className={classes.faqItem}>
                                <PlansFaq
                                    header={faq.question}
                                    content={faq.answer}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

const BusinessHomepage = () => {
    const isLoggedIn = useSelector(userSelectors.isLoggedIn)

    return (
        <>
            <header className={classes.header}>
                <img
                    src={heroBackgroundImage}
                    alt=""
                    className={classes.headerImage}
                />
                <nav className={classes.nav}>
                    <Link to={'/'}>
                        <img
                            src={logo}
                            alt="Logo"
                            className={classes.navLogo}
                        />
                    </Link>
                    <div className={classes.navLinks}>
                        <Link
                            to={'/app/browse/courses'}
                            className={classes.navLink}
                        >
                            Courses
                        </Link>
                        {!isLoggedIn && (
                            <Link
                                to={'/app/auth/sign-in'}
                                className={classes.navLink}
                            >
                                Log In
                            </Link>
                        )}
                        {/* <Link to={'/plans'} className={classes.navLink}>
                            Pricing
                        </Link> */}
                        {isLoggedIn ? (
                            <Button
                                className={classes.navLinkLarge}
                                to={'/app'}
                            >
                                Go to Dashboard
                            </Button>
                        ) : (
                            <Button
                                className={classes.navLinkLarge}
                                to={'/app/business/sign-up'}
                            >
                                Sign Up
                            </Button>
                        )}
                    </div>
                </nav>
                <div className={classes.headerText}>
                    <h1 className={classes.headerTextMain}>
                        Learn. Implement. Grow!
                    </h1>
                    <p className={classes.headerTextSub}>
                        Upturn for Business offers an all-in-one solution to
                        implementing your business processes in the workplace.
                        Subscribe to our Plan to grow with your team.
                    </p>
                    <Button to={'/app/business/sign-up'}>
                        Get Started
                        <ButtonIcon icon={<RightArrow />} />
                    </Button>
                </div>
                <button className={classes.downButton}>
                    <DownIcon />
                </button>
            </header>
            <main className={classes.main}>
                {/*TODO: Add background image*/}
                <h1 className={classes.growText}>Why should I subscribe?</h1>
                <section
                    className={classNames(classes.perks, gridClasses.container)}
                >
                    <div className={classes.perk}>
                        <div>
                            <span className={classes.perkNumber}>01</span>
                            <h2 className={classes.perkHeader}>
                                Two Courses Per Month
                            </h2>
                            <p className={classes.perkDescription}>
                                Subscribing for Upturn for Business gives you
                                and your team access to two free courses EACH
                                MONTH. Our course library is updated weekly to
                                give you more opportunities each month.
                            </p>
                        </div>
                        <img src={Perk1} className={classes.perkImage} />
                    </div>
                    <div className={classes.perk}>
                        <img src={Perk2} className={classes.perkImage} />
                        <div>
                            <span className={classes.perkNumber}>02</span>
                            <h2 className={classes.perkHeader}>
                                Quarterly Free Recruitment
                            </h2>
                            <p className={classes.perkDescription}>
                                As a registered business on our learning
                                platform, you are entitled to a quarterly free
                                recruitment service at no extra charge. T&Cs
                                apply.
                            </p>
                        </div>
                    </div>
                    <div className={classes.perk}>
                        <div>
                            <span className={classes.perkNumber}>03</span>
                            <h2 className={classes.perkHeader}>
                                Tools And Templates
                            </h2>
                            <p className={classes.perkDescription}>
                                Get essential resources and learning materials
                                delivered straight to your doorstep in our
                                classic QUARTERLY CUSTOM BOX
                            </p>
                        </div>
                        <img src={Perk3} className={classes.perkImage} />
                    </div>
                    <div className={classes.perk}>
                        <div>
                            <span className={classes.perkNumber}>04</span>
                            <h2 className={classes.perkHeader}>
                                A Dedicated Relationship Manager
                            </h2>
                            <p className={classes.perkDescription}>
                                In a bid to walk you through the entire process
                                ourselves, we provide a dedicated Relationship
                                Manager, who would see to it that you are never
                                at a loss at any stage.
                            </p>
                        </div>
                        <img src={Perk4} className={classes.perkImage} />
                    </div>
                </section>
                <section className={classes.plansSection}>
                    <div
                        role="presentation"
                        className={classes.plansSectionBackground}
                    />
                    <div
                        className={classNames(
                            gridClasses.container,
                            gridClasses.containerTransparent
                        )}
                    >
                        <h1 className={classes.planHeader}>
                            Click here to choose a plan.
                        </h1>
                        <p className={classes.planText}>
                            SME Upturn is your one stop shop to help you grow
                            your business
                        </p>
                        {/* <div className={classes.plansGrid}>
                            {plans.map((plan, idx) => (
                                <PlanCard {...plan} key={idx} />
                            ))}
                        </div>
                        <div className={classes.plansCarousel}>
                            <Carousel
                                slideClassName={classes.planSlideWrapper}
                                dots
                                dotBg={'#EB6324'}
                                dotClass={classes.dot}
                            >
                                {plans.map((plan, idx) => (
                                    <PlanCard
                                        {...plan}
                                        key={idx}
                                        className={classes.planSlide}
                                    />
                                ))}
                            </Carousel>
                        </div> */}
                        <BusinessPlans />
                    </div>
                </section>
            </main>
            <section
                className={classes.learningWrapper}
                style={{ backgroundImage: `url(${Doodle})` }}
            >
                <div
                    className={classNames(
                        gridClasses.container,
                        gridClasses.containerTransparent,
                        classes.learningContainer
                    )}
                >
                    <div>
                        <h1 className={classes.learningHeader}>
                            Get Started. Start Implementing
                        </h1>
                        <p className={classes.learningText}>
                            Take the bold step and delve into the learning
                            process now. We'll be waiting on the other side.
                        </p>
                    </div>
                    <Button
                        className={classes.learningButton}
                        to={'/app/business/sign-up'}
                    >
                        Start learning
                    </Button>
                </div>
            </section>
            <FAQSection />
            <Footer />
        </>
    )
}

const PlanCard = ({
    title,
    price,
    cycle,
    description,
    buttonBg = '#EB6324',
    features,
    className,
}) => (
    <section className={classNames(classes.plan, className)}>
        <h5 className={classes.planName}>{title}</h5>
        <p className={classes.planPrice}>{convertToFormatted(price)}</p>
        <p className={classes.planCycle}>/{cycle}</p>
        <p className={classes.planDescription}>{description}</p>
        <Button
            style={{
                backgroundColor: buttonBg,
                borderColor: buttonBg,
            }}
        >
            Select Plan
        </Button>
        <h6 className={classes.planFeaturesHeader}>Plan Includes</h6>
        <ul className={classes.planFeatures}>
            {features.map((feature, idx) => (
                <li key={idx} className={classes.planFeature}>
                    {feature}
                </li>
            ))}
        </ul>
    </section>
)

export default BusinessHomepage
